import { Content, asText } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import {
  HeadingElementMarkup,
  Heading as OxygenHeading,
} from '@preventx/oxygen';

export type HeadingProps = SliceComponentProps<Content.HeadingSlice>;

const Heading = ({ slice }: HeadingProps) => {
  const { primary, variation } = slice;

  const component = {
    heading1: 'h1' satisfies HeadingElementMarkup,
    heading2: 'h2' satisfies HeadingElementMarkup,
    heading3: 'h3' satisfies HeadingElementMarkup,
  }[variation] as HeadingElementMarkup;

  return (
    <OxygenHeading component={component}>{asText(primary.title)}</OxygenHeading>
  );
};

export default Heading;
